import React, { useEffect, useState } from "react";
import AreaOrdiniPRE from "./AreaOrdiniPRE";
import ContainerLoaderCharts from "./Charts/ContainerLoaderCharts";
import apiUrl from "../Apiurl";
import stilePulsanti from "../interfaccia/stilePulsanti";

function AreaCheckSparati({
  autenticazione,
  objRicercheRapideDBOrdini,
  temaColori,
  inputVuoto,
  vistaINIT,
  magCheck, 
  setMagCheck
}) {

  const mag=magCheck
  const magazzini = [
    "Prato Nevoso",
    "Torino",
    "Villanova Mondovì",
    "Vernante",
    "Limone 1400",
    "Borgo San Dalmazzo",
    "Limone",
    "Magazzino Marro (area VS)",
    "Magazzino Marro",
  ]
  let indexMagAttuale = magazzini.indexOf(magCheck)


  let key1 = [11+indexMagAttuale]
  let key2 = [12+indexMagAttuale]
  let key3 = [13+indexMagAttuale]
  let key4 = [14+indexMagAttuale]

  const {
    tastoSXAspetto,
    tastoDXAspetto
  } = stilePulsanti
  
  return (<div className='flex flex-wrap sfondoBiancoTema'>
  <div className='wpx-300 sfondoBiancoTema br bordoColAlt'>
    <div className="flex justify-between tc f4 b sfondoColScuro pa3">
      { indexMagAttuale > 0 && <div className="pointer nonSelezionabile" onClick={()=>setMagCheck(magazzini[indexMagAttuale-1])}>{tastoSXAspetto}</div>}
      { indexMagAttuale <= 0 && <div className="pointer nonSelezionabile scrittaColScuro">{tastoSXAspetto}</div>}
      <div className="ttu">{mag}</div>
      { indexMagAttuale < magazzini.length - 1 && <div className="pointer nonSelezionabile" onClick={()=>setMagCheck(magazzini[indexMagAttuale+1])}>{tastoDXAspetto}</div>}
      { indexMagAttuale >= magazzini.length - 1 && <div className="pointer nonSelezionabile scrittaColScuro">{tastoDXAspetto}</div>}
    </div>
  {/* <div className="tc sfondoColChiaro pa2 b">Stats</div> */}
      <ContainerLoaderCharts
        query={"/logistica/sparaOrdini/spedizioniOggiMag/"+encodeURI(mag)}
        titolo="Stats"
        displayTitolo={false}
        key={key4}
      />
    </div>
  <div className='flex wpx-totMeno300'>
  <div className='w-50 br bordoColAlt '>
    <AreaOrdiniPRE
      vistaINIT={vistaINIT}
      titolo="Devono partire"
      colonna='1'
      utente={autenticazione}
      ricercaIniz={objRicercheRapideDBOrdini.tutti}
      tema={temaColori}
      urlRicercaINIT={apiUrl + "/logistica/sparaOrdini/devonoPartireDaMag/"+encodeURI(mag)+"/"}
      perPageINIT={200}
      inputVuoto={inputVuoto}
      keyArea={key1}
    />
  </div>
  <div className='w-50'>
    

    <AreaOrdiniPRE
      vistaINIT={vistaINIT}
      titolo="Partono senza codice PS"
      colonna='2'
      utente={autenticazione}
      ricercaIniz={objRicercheRapideDBOrdini.tutti}
      tema={temaColori}
      urlRicercaINIT={apiUrl + "/logistica/sparaOrdini/devonoPartireMaNonHannoCodice/"+encodeURI(mag)+"/"}
      perPageINIT={200}
      inputVuoto={inputVuoto}
      keyArea={key2}
    />

    <AreaOrdiniPRE
      vistaINIT={vistaINIT}
      titolo="Sparati ma non partono"
      colonna='2'
      utente={autenticazione}
      ricercaIniz={objRicercheRapideDBOrdini.tutti}
      tema={temaColori}
      urlRicercaINIT={apiUrl + "/logistica/sparaOrdini/sparatiDaMagNonDevonoPartire/"+encodeURI(mag)+"/"}
      perPageINIT={200}
      inputVuoto={inputVuoto}
      keyArea={key3}
    />
  </div>
  </div>
  
  
</div>)

}

export default AreaCheckSparati;
